import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  ModalBody,
} from "reactstrap";
import { ComonIcons } from "../../contents/commonIcons";
import Title from "../title";
import ComingSoon from "../../views/pages/soon";
import { setAddProgramModalOpen } from "../../redux/actions/trainer/trainerAction";

export const AddProgramModal = () => {
  const dispatch = useDispatch();
  const { addProgramModalopen } = useSelector((state) => state.trainer);
  const toggle = () => dispatch(setAddProgramModalOpen(!addProgramModalopen));

  return (
    <Modal
      centered={true}
      size="lg"
      className="large-pop adding-popup "
      isOpen={addProgramModalopen}
      toggle={toggle}
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Add Program" />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>
            <ComingSoon />
        </div>
      </ModalBody>
    </Modal>
  );
};
